const getMessagesFromModules = (modules) => modules[0].default

const configureLocale = async (language: string) => {
  switch (language) {
    case 'de':
      return Promise.all([
        import('lang/de.json'),
        import('@formatjs/intl-relativetimeformat/locale-data/de')
      ]).then(getMessagesFromModules)
    case 'en':
      return Promise.all([
        import('lang/en.json'),
        import('@formatjs/intl-relativetimeformat/locale-data/en')
      ]).then(getMessagesFromModules)
    case 'es':
      return Promise.all([
        import('lang/es.json'),
        import('@formatjs/intl-relativetimeformat/locale-data/es')
      ]).then(getMessagesFromModules)
    case 'es-la':
      return Promise.all([
        import('lang/es-la.json'),
        import('@formatjs/intl-relativetimeformat/locale-data/es')
      ]).then(getMessagesFromModules)
    case 'fr':
      return Promise.all([
        import('lang/fr.json'),
        import('@formatjs/intl-relativetimeformat/locale-data/fr')
      ]).then(getMessagesFromModules)
    case 'it':
      return Promise.all([
        import('lang/it.json'),
        import('@formatjs/intl-relativetimeformat/locale-data/it')
      ]).then(getMessagesFromModules)
    case 'pt':
      return Promise.all([
        import('lang/pt.json'),
        import('@formatjs/intl-relativetimeformat/locale-data/pt')
      ]).then(getMessagesFromModules)
    case 'ru':
      return Promise.all([
        import('lang/ru.json'),
        import('@formatjs/intl-relativetimeformat/locale-data/ru')
      ]).then(getMessagesFromModules)
    case 'tr':
      return Promise.all([
        import('lang/tr.json'),
        import('@formatjs/intl-relativetimeformat/locale-data/tr')
      ]).then(getMessagesFromModules)
    default:
      return Promise.all([
        import('lang/en.json'),
        import('@formatjs/intl-relativetimeformat/locale-data/en')
      ]).then(getMessagesFromModules)
  }
}

export default configureLocale
